import { Box, Typography } from '@mui/material';
import Image from 'next/image';
import { DesktopPaddingLarger, MobilePadding } from 'pages';
import { Colors } from './NewWebsite/NavigationMenu';
import { ContainerMaxWidth } from './organisms/layouts/Layout';
export const METRICS = [{
  bgColor: Colors.White,
  metric: 'Maintain gross profits',
  description: 'Protect your EV gross profits with better data and tools for your sales & finance team'
}, {
  bgColor: '#C1E8D0',
  metric: 'Empower EV shoppers',
  description: 'Engage more EV shoppers with useful data and visuals to help them make quicker decisions'
}, {
  bgColor: '#D6EAFF',
  metric: 'Turn units faster',
  description: 'Allow your marketing team to bring warmer EV leads and help your sales team close more deals'
}];
export const Metrics = () => {
  return <Box sx={{
    backgroundColor: Colors.CeruleanBlue,
    padding: {
      xs: MobilePadding,
      md: DesktopPaddingLarger
    },
    height: '100%',
    width: '100%'
  }}>
      <Box sx={{
      maxWidth: ContainerMaxWidth,
      mx: 'auto'
    }}>
        <Typography sx={{
        color: Colors.White,
        fontSize: '38px',
        fontWeight: 600,
        textAlign: 'center',
        lineHeight: {
          xs: 1,
          md: 1.5
        },
        mb: {
          xs: '1rem',
          md: '4rem'
        }
      }}>
          Why add EV badges?
        </Typography>

        <Box sx={{
        display: 'flex',
        alignItems: 'normal',
        justifyContent: 'space-between',
        width: '100%',
        gap: '5%',
        flexDirection: {
          xs: 'column',
          md: 'row'
        }
      }}>
          {METRICS.map((item, i) => <Box key={i} sx={{
          backgroundColor: item?.bgColor,
          borderRadius: '2px',
          padding: {
            xs: '30px',
            md: '40px'
          },
          flex: '1',
          // Makes each box take equal space
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '1rem'
        }}>
              <Image src="/assets/images/zap.png" width={15} height={15} alt="" />
              <Typography sx={{
            fontSize: '30px',
            fontWeight: 700,
            textAlign: 'center'
          }}>{item?.metric}</Typography>
              <Typography sx={{
            color: '#44485A',
            textAlign: 'center',
            fontSize: '14px'
          }}>
                {item?.description}
              </Typography>
            </Box>)}
        </Box>
      </Box>
    </Box>;
};